import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { FormContextValues } from '@dreryk/react-common';

import { PatientSelectIdentifierType } from '../PatientIdentifierTypeField/PatientIdentifierTypeField';
import { PersonalIdentifierType } from '../../common.types';

import { GenderField } from './GenderField';
import { GenderTextView } from './GenderTextView';

type GenderFormBeanPart = {
   personalIdentifierType: PatientSelectIdentifierType;
   pesel?: Pesel | null;
};

type GenderProps = Pick<FormContextValues<GenderFormBeanPart>, 'register' | 'watch'>;

export const Gender = (props: GenderProps): JSX.Element => {
   const { personalIdentifierType, pesel } = props.watch(['personalIdentifierType', 'pesel']);

   if (personalIdentifierType.id === PersonalIdentifierType.PESEL) {
      return <GenderTextView gender={pesel?.getGender() ?? null} />;
   }

   return <GenderField register={props.register} personalIdentifierType={personalIdentifierType} />;
};
